import sample from './sample.js';

// Shuffle a collection.
export default function shuffle(obj) {
  return sample(obj, Infinity);
}



//////////////////
// WEBPACK FOOTER
// /Users/elizabeth.chen/Documents/Work/2/int-vue-productpool/node_modules/underscore/modules/shuffle.js
// module id = 475
// module chunks = 1